import { render } from "./List.vue?vue&type=template&id=e73f5948"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"

import "./List.vue?vue&type=style&index=0&id=e73f5948&lang=css"

import exportComponent from "/home/darnell/Development/accounting/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__